import React, { useEffect, useState, useContext } from 'react';
import { documentDefinition, attributeDefinition } from '../../types/Search';
import ImageService from '../../services/ImageService';
import { useOktaAuth } from '@okta/okta-react';
import ImageDataContext from '../../providers/imageData-context';

export interface Props {
    fileName: string;
    large?: boolean;
}

export const TooltipContentOnDemand: React.FC<Props> = (props) => {
    const { oktaAuth, authState } = useOktaAuth();

    const imageDataCtx = useContext(ImageDataContext);

    let uid: string = '';
    let cid: string = '';
    let accessToken: string = '';
    let groupName: string = '';
    let userEmail: string = '';

    if (authState.isAuthenticated) {
        userEmail = authState.accessToken.claims?.sub;
        uid = authState.accessToken.claims?.uid;
        cid = authState.accessToken.claims?.cid;
        accessToken = authState.accessToken.accessToken;
    }

    useEffect(() => {
        if (!authState) return;
        if (props.fileName === undefined) return;

        let imageDetailsFromCache = imageDataCtx.cachedImageDetails.filter(
            (x) => x.name === props.fileName
        );
        if (imageDetailsFromCache.length === 0) {
            imageDataCtx.loadImageDetails(props.fileName);
        }
    }, [props.fileName, imageDataCtx.cachedImageDetails]);

    if (!authState) {
        return <div></div>;
    }

    let imageDetailsFromCache = imageDataCtx.cachedImageDetails.filter(
        (x) => x.name === props.fileName
    );
    if (imageDetailsFromCache.length == 0) {
        return <span>Loading...</span>;
    }

    const loadedDocument = imageDetailsFromCache[0];

    let cleanedAttributes: attributeDefinition[] = [];

    const uniqueAttributeNames = loadedDocument.attributes
        .map((att) => att.name)
        .filter((value, index, self) => self.indexOf(value) === index);
    cleanedAttributes = uniqueAttributeNames.map((name) => {
        const matchingAttributes = loadedDocument.attributes.filter((att) => att.name == name);
        const newAttribute = { ...matchingAttributes[0] };
        const uniqueValues: string[] = [];
        matchingAttributes.forEach((att) =>
            uniqueValues.push(...att.value.split(',').map((x) => x.trim()))
        );
        newAttribute.value = uniqueValues
            .filter((value, index, self) => self.indexOf(value) === index)
            .join(', ');
        return newAttribute;
    });

    const filteredAndSortedAttributes = cleanedAttributes
        .filter((a) => a.displayOrder != '-1')
        .sort((a1, a2) => (a1.displayOrder < a2.displayOrder ? -1 : 1));

    const nameStyle = {
        fontSize: `${props.large ? '12pt' : '10pt'}`,
    };

    const valueStyle = {
        paddingLeft: '5px',
        fontSize: `${props.large ? '12pt' : '10pt'}`,
    };

    return (
        <>
            <table className='image-info-popup'>
                <tbody>
                    <tr>
                        <td>
                            <span style={nameStyle}>State:</span>
                            <span style={valueStyle}>{loadedDocument.state}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span style={nameStyle}>County:</span>
                            <span style={valueStyle}>{loadedDocument.county}</span>
                        </td>
                    </tr>
                    {loadedDocument.imageType !== 'HIERARCHY' && (
                        <>
                            <tr>
                                <td>
                                    <span style={nameStyle}>Type:</span>
                                    <span style={valueStyle}>{loadedDocument.imageType}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span style={nameStyle}>SubType:</span>
                                    <span style={valueStyle}>{loadedDocument.imageSubType}</span>
                                </td>
                            </tr>
                        </>
                    )}
                    {filteredAndSortedAttributes.map((attribute) => {
                        return (
                            <tr>
                                <td>
                                    <span style={nameStyle}>
                                        {attribute.description.replaceAll('_', ' ')}:
                                    </span>
                                    <span style={valueStyle}>{attribute.value}</span>
                                </td>
                            </tr>
                        );
                    })}
                    {loadedDocument.byteCount !== 0 && (
                        <tr>
                            <td>
                                <span style={nameStyle}>File Size:</span>
                                <span style={valueStyle}>{loadedDocument.byteCount}</span>
                            </td>
                        </tr>
                    )}
                    {loadedDocument.pageCount !== 0 && (
                        <tr>
                            <td>
                                <span style={nameStyle}>No. of page(s):</span>
                                <span style={valueStyle}>{loadedDocument.pageCount}</span>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </>
    );
};

export default TooltipContentOnDemand;
